import { render } from "./myFooter.vue?vue&type=template&id=136654ca&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"

import "./myFooter.vue?vue&type=style&index=0&id=136654ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136654ca"]])

export default __exports__